import type { FC } from 'react';
import { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';

import type { PreloadControllerProps } from './types';

export * from './types';

export const PreloadController: FC<PreloadControllerProps> = (props) => {
  const { images } = props;

  const preloadedImages = useMemo(() => {
    if (Array.isArray(images)) {
      const uniqueImages = Array.from(new Set(images));
      return uniqueImages.map((img) => (
        <link key={img} rel="preload" as="image" href={img as string} />
      ));
    }
    return [];
  }, [images]);

  if (!preloadedImages.length) {
    return null;
  }
  return <Helmet>{preloadedImages}</Helmet>;
};
